﻿import { containerAccessGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("container-access-groups"),
  endpoint: "container-access-groups",
  operations: containerAccessGroupsOps,
  roleView: [ROLE.LARGE_LIST_ADMIN, ROLE.LARGE_LIST_VIEW],
  roleAdmin: [ROLE.LARGE_LIST_ADMIN],
  dependencies: ["container"],
  singularName: (t) => t("Container access groups"),
  name: (t) => t("Container access group"),
  syncCustomerFilter: true,
});

export default conf;
